import { render, staticRenderFns } from "./ColumnConfigTool.vue?vue&type=template&id=7005a5d5&scoped=true&"
import script from "./ColumnConfigTool.vue?vue&type=script&lang=js&"
export * from "./ColumnConfigTool.vue?vue&type=script&lang=js&"
import style0 from "./ColumnConfigTool.vue?vue&type=style&index=0&id=7005a5d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005a5d5",
  null
  
)

export default component.exports